import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { Document, Page, pdfjs } from 'react-pdf';
import "react-pdf/dist/esm/Page/TextLayer.css";
import { GetCoSinger, GetCoSingerReport, GetViewRentalApp } from '../../../lib/Api/RantelServiceApi';
import { Loader } from '../../../utils/loaderButton';
import { toast } from 'react-toastify';
import GaugeChart from './CreditGuage';
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
const ViewRentalApp = ({ list }) => {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [tabNo, setTabNo] = useState(0);
    const [file, setFile] = useState("")
    const [type, setType] = useState("")
    const [credit, setCredit] = useState("")
    const [loading, setLoading] = useState(false)
    const [loadingCoSinger, setLoadingCoSinger] = useState(false)
    const [coSingers, setCoSingers] = useState([])
    const [selectedCoSign, setSelectedCoSign] = useState({})
    // const [selectedLoading, setSelectedLoading] = useState(false)



    const handleLoardPdf = async (reportType, types) => {
        setType(types)
        if (tabNo === 0) {
            try {
                let payload = {
                    "list_id": list?.id,
                    "report_type": reportType
                }
                setLoading(true)
                let res = await GetViewRentalApp(payload)
                // console.log("REs", res)
                if (res) {
                    let obj = Object.assign({}, ...res)
                    setLoading(false)
                    if (obj?.report_url === null) {
                        toast.error("Report not Available")
                    }
                    else if (reportType === "credit_report") {
                        if (obj?.report !== null) {
                            setCredit(obj?.report?.score)
                        } else {
                            setCredit(0)
                        }
                    }
                    else {
                        setFile(obj?.report_url)
                    }
                }
            }
            catch (err) { }
        }
        else {
            handleFetchCoSigner(selectedCoSign, reportType)
        }
    }

    const handleFetchAllCoSigner = async () => {
        try {
            setLoadingCoSinger(true)
            let payload = {
                "list_id": list?.id,
            }
            let res = await GetCoSinger(payload)
            debugger
            if (res) {
                // let obj = Object.assign({}, ...res)
                setCoSingers(res)
                setLoadingCoSinger(false)
            }
        }
        catch (err) { }
    }

    const handleTab = (index, id) => {
        setTabNo(index)
        setSelectedCoSign(id)
    }

    const handleFetchCoSigner = async (id, reportType) => {
        // setSelectedCoSign(id)

        try {
            setLoading(true)
            let payload = {
                "report_type": reportType,
                "list_id": list?.id,
            }
            let res = await GetCoSingerReport(id, payload)
            if (res) {
                let obj = Object.assign({}, ...res)
                setLoading(false)
                if (obj?.report_url === null) {
                    toast.error("Report not Available")
                }
                else {
                    setFile(obj?.report_url)
                }
            }
        }
        catch (err) { }
    }

    // Pdf Views
    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }
    const handleNextpage = () => {
        let val = pageNumber
        setPageNumber(val + 1)
    }
    const handlePrv = () => {
        let val = pageNumber
        setPageNumber(val - 1)
    }


    useEffect(() => {
        handleFetchAllCoSigner()
    }, [])

    const { t } = useTranslation()

    return (
        <>
            {
                file !== "" ?
                    <>
                        {file !== "" &&
                            <div className='cursor-pointer font-bold pb-2' onClick={() => setFile('')}>
                                {t('Back')}
                            </div>
                        }
                        <Document
                            file={file}
                            className="flex justify-center h-auto  items-center"
                            onLoadSuccess={onDocumentLoadSuccess}>
                            <Page pageNumber={pageNumber} renderTextLayer={false} />
                        </Document>
                        <div className='flex justify-center  items-center flex-col'>
                            <p>
                                {t('page')} {pageNumber} {t('of')} {numPages}
                            </p>
                            <div className='flex items-center justify-center'>
                                {pageNumber > 1 &&
                                    <button className='font-semibold mx-3 bg-[#F79F15] px-6 py-2 text-white rounded-md' onClick={() => handlePrv()}>{t('prev_lbl')}</button>
                                }
                                {pageNumber < numPages &&
                                    <button className='font-semibold bg-[#F79F15] px-6 py-2 text-white rounded-md' onClick={() => handleNextpage()}>{t('next_lbl')}</button>
                                }
                            </div>
                        </div>
                    </>
                    :
                    credit !== "" ?
                        <div className='flex justify-center items-center'>
                            <GaugeChart credit={credit} setCredit={setCredit} />
                        </div>
                        :
                        loadingCoSinger ? <Loader type="loadData" /> :
                            <div className="flex flex-col justify-between items-center p-2">
                                <div className='flex  gap-5'>
                                    <ul className='xl:flex lg:flex hidden items-center border-b lg:max-w-[560px] md:max-w-[420px]  '>
                                        <li onClick={() => setTabNo(0)} className={`font-bold text-[18px]  cursor-pointer first:ml-0 pb-2 ${tabNo === 0 && 'border-[#F79F15] border-b-2'} `}>
                                            {t('main_rentals')}
                                        </li>
                                        {
                                            coSingers.map((item, i) => (
                                                <li key={i} className={`lg:ml-[3rem] ml-[1rem] cursor-pointer first:ml-0 ${tabNo === i + 1 && "border-[#F79F15] border-b-2"}  pb-2  font-bold text-[18px]`} onClick={() => handleTab(i + 1, item?.id)}>
                                                    <span className='text-black font-semibold'>{t('co_signer_label')} {i + 1}</span>
                                                </li>

                                            ))
                                        }
                                    </ul>
                                    {/* <button className='bg-[#F79F15] px-4 py-2 rounded-md text-white' >
                                    {t('main_rentals')}
                                </button>
                                <div className='flex justify-center items-center'>
                                    {loadingCoSinger ? <Loader type="loader" /> : null}
                                </div>
                                <div>
                                    {
                                        !loadingCoSinger && coSingers?.map((item, index) => {
                                            return (
                                                <button key={index} className='bg-[#F79F15] px-4 py-2 rounded-md text-white' onClick={() => handleFetchCoSigner(item?.id)}>
                                                    {selectedLoading && selectedCoSign === item?.id ? <Loader type="single" /> : <span className='text-white font-semibold'>{`${item?.first_name} ${item?.last_name} `}  </span>}
                                                </button>
                                            )
                                        })
                                    }
                                </div> */}
                                </div>
                                <ul className='mt-5'>
                                    {/* <li onClick={() => handleLoardPdf("liens_and_judgements", "liens")} className='h-[60px] cursor-pointer text-[18px] flex justify-center items-center border-b pb-2'>
                                    {loading && type === "liens" ? <Loader type="loadData" /> : "View Liens & Judgements"}
                                </li> */}
                                    <li className='h-[60px] cursor-pointer text-[18px] w-full gap-20 flex justify-between items-center border-b  '>
                                        <p className='text-left w-full'> {t('report_1')}</p>
                                        <button className='bg-[#F79F15] px-4 py-2 rounded-md text-white' onClick={() => handleLoardPdf("criminal_report", "criminal")}>
                                            {loading && type === "criminal" ? <Loader type="single" /> : <span className='text-white font-semibold'>{t('view')}</span>}
                                        </button>
                                    </li>
                                    <li className='h-[60px] cursor-pointer text-[18px] w-full gap-20 flex  items-center border-b  '>
                                        <p className='text-left w-full'> {t('report_2')}</p>
                                        <button className='bg-[#F79F15] flex jus px-4 py-2 rounded-md text-white' onClick={() => handleLoardPdf("credit_report", "credit")}>
                                            {loading && type === "credit" ? <Loader type="single" /> : <span className='text-white font-semibold'>{t('view')}</span>}
                                        </button>
                                        {/* {loading && type === "credit" ? <Loader type="single" /> : t('report_2')} */}
                                    </li>
                                    <li className='h-[60px] cursor-pointer text-[18px] w-full gap-20 flex justify-center items-center border-b  '>
                                        <p className='text-left w-full'> {t('report_3')}</p>
                                        <button className='bg-[#F79F15] px-4 py-2 rounded-md text-white' onClick={() => handleLoardPdf("evictions", "evictions")}>
                                            {loading && type === "evictions" ? <Loader type="single" /> : <span className='text-white font-semibold'>{t('view')}</span>}
                                        </button>
                                        {/* {loading && type === "evictions" ? <Loader type="single" /> : t('report_3')} */}
                                    </li>
                                    <li className='h-[60px] cursor-pointer text-[18px] w-full gap-20 flex justify-center items-center  '>
                                        <p className='text-left w-full'> {t('report_4')} </p>
                                        <button className='bg-[#F79F15] px-4 py-2 rounded-md text-white' onClick={() => handleLoardPdf("rental_application", "rentalapp")}>
                                            {loading && type === "rentalapp" ? <Loader type="single" /> : <span className='text-white font-semibold'>{t('view')}</span>}
                                        </button>
                                        {/* {loading && type === "rentalapp" ? <Loader type="loadData" /> : t('report_4')} */}

                                    </li>
                                </ul>
                            </div>

            }
        </>
    )
}

export default ViewRentalApp